import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { api } from '../lib/api';

/**
 * Returns consecutive-days-worked counts for all active staff for every date in [from, to].
 * Shape: { [dateStr: string]: { [staffId: string]: number } }
 * Used by ContractsBoard to show per-column WTR chip colours.
 * Invalidated on assignment create / delete / update.
 */
export function useConsecutiveDaysByDate(from: Date, to: Date) {
  const fromStr = format(from, 'yyyy-MM-dd');
  const toStr   = format(to,   'yyyy-MM-dd');
  return useQuery({
    queryKey: ['staff', 'consecutive-days-range', fromStr, toStr],
    queryFn: () => api.staff.consecutiveDaysRange(fromStr, toStr),
    staleTime: 5 * 60 * 1000,
  });
}
